export default "__VITE_ASSET__Cd8Ol3SM__"